export const OVERVIEW_GET_OVERVIEW_DATA_BEGIN = 'OVERVIEW_GET_OVERVIEW_DATA_BEGIN';
export const OVERVIEW_GET_OVERVIEW_DATA_SUCCESS = 'OVERVIEW_GET_OVERVIEW_DATA_SUCCESS';
export const OVERVIEW_GET_OVERVIEW_DATA_FAILURE = 'OVERVIEW_GET_OVERVIEW_DATA_FAILURE';
export const OVERVIEW_GET_OVERVIEW_DATA_DISMISS_ERROR = 'OVERVIEW_GET_OVERVIEW_DATA_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/overview/redux/constants.js